import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faLanguage } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import axios from "axios";
import Breadcrumbs from "../../Navigation/Components/Breadcrumbs";
import { useTranslation } from "react-i18next";
import "./NewTrainingGroupForm.css";

function NewTrainingGroupForm() {
  const [name, setName] = useState("");
  const [name_english, setNameEnglish] = useState("");

  const [english, setEnglish] = useState(false);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    async function fetch() {
      if (state.language === "en") {
        setEnglish(true);
      } else {
        setEnglish(false);
      }
    }
    fetch();
  }, [state.language]);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleNameEnglishChange = (e) => {
    setNameEnglish(e.target.value);
  };

  const activateEnglish = () => {
    setEnglish(true);
  };

  const handleSubmit = async (e) => {
    try {
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingGroups`,
        data: {
          name: name,
          name_english: name_english,
          organization: state.organization,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/trainings/training-groups");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  let breadcrumbs = [
    {
      title: state.language === "es" ? "Capacitaciones" : "Trainings",
      path: "/trainings",
    },
    {
      title:
        state.language === "es"
          ? "Grupos de capacitaciones"
          : "Training Groups",
      path: "/trainings/training-groups",
    },
  ];

  return (
    <Container fluid>
      <Row>
        <Breadcrumbs data={breadcrumbs} />
      </Row>
      <Row>
        <Col lg={11} className="new-training-header">
          <h2>{t("Capacitaciones.GruposDeCapacitacion.NuevoGrupo")}</h2>
        </Col>
        <Col lg={1} className="new-scale-header mb-2">
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <FontAwesomeIcon icon={faList} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={activateEnglish}>
                <FontAwesomeIcon icon={faLanguage} /> English
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      <Row>
        <Col className="new-training-form">
          <Form>
            <FloatingLabel
              controlId="floatingInput"
              label="Nombre del grupo"
              className="mb-3"
            >
              <Form.Control
                type="text"
                placeholder="nombre del grupo"
                onChange={handleNameChange}
              />
            </FloatingLabel>
            {english ? (
              <FloatingLabel label="Group title" className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Group title"
                  onChange={handleNameEnglishChange}
                />
              </FloatingLabel>
            ) : (
              <></>
            )}
            <Button className="primary" onClick={handleSubmit}>
              {t("Capacitaciones.GruposDeCapacitacion.Guardar")}
            </Button>
            <Link to="/trainings/training-groups">
              <Button className="danger">
                {t("Capacitaciones.GruposDeCapacitacion.Cancelar")}
              </Button>
            </Link>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default NewTrainingGroupForm;
